﻿export function JsonStrToDate(str) {
  try {
    let ano = parseInt(str.substr(0, 4));
    let mes = parseInt(str.substr(5, 2));
    let dia = parseInt(str.substr(8, 2));
    let hora = parseInt(str.substr(11, 2));
    let min = parseInt(str.substr(14, 2));
    let seg = parseInt(str.substr(17, 2));

    if (ano > 0)
      return new Date(ano, mes - 1, dia, hora, min, seg, 0);
  } catch (ex) {
  }
  return null;
}

export function NumeroValido(numero) {
  if (isNaN(numero)) {
    return false;
  } else {
    if ((numero === undefined) || (numero == null))
      return false;
  }
  return true;
}

export function StrToDate(str) {
  //2016/12/21
  /*ano = str.substr(0, 4);
  mes = str.substr(5, 2);
  dia = str.substr(8, 2);*/

  //21/12/2016 17:30
  let ano = str.substr(6, 4);
  let mes = str.substr(3, 2);
  let dia = str.substr(0, 2);
  return new Date(ano, mes - 1, dia);
}

export function StrToDateTime(str) {
  //21/12/2016 17:30
  let ano = str.substr(6, 4);
  let mes = str.substr(3, 2);
  let dia = str.substr(0, 2);
  let hora = str.substr(11, 2);
  let min = str.substr(14, 2);

  return new Date(ano, mes - 1, dia, hora, min, 0);
}

window.StrToDateTimeMS = function (str) {
  try {
    //aaaa/MM/dd 17:30:00.999
    let ano = parseInt(str.substr(0, 4));
    let mes = parseInt(str.substr(5, 2));
    let dia = parseInt(str.substr(8, 2));
    let hora = parseInt(str.substr(11, 2));
    let min = parseInt(str.substr(14, 2));
    let seg = parseInt(str.substr(17, 2));
    let ms = parseInt(str.substr(20, 3));

    if (ano > 0)
      return new Date(Date.UTC(ano, mes - 1, dia, hora, min, seg, ms));
  } catch (ex) {
  }
  return null;
}

export function StrToDateUTC(str) {
  let ano = str.substr(0, 4);
  let mes = str.substr(5, 2);
  let dia = str.substr(8, 2);

  let d = new Date(ano, mes - 1, dia);
  d.setHours(d.getHours() - d.getTimezoneOffset() / 60);
  return d;
}

export function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

window.PegaConfig = function (cb) {
  try {
    $.ajax({
      dataType: "json",
      url: url + "enet/getConfig",
      success: function (data) {
        window.config = data;
        if (cb) {
          cb()
        }
      }
    });

  } catch (ex) {
    console.log(ex);
  }
}

export function avisoAguarde() {
  if (document.getElementById('divProcessando')) {
    document.getElementById('divProcessando').style.display = '';
    return;
  }

  let oDiv = document.createElement("div");

  oDiv.id = "divProcessando";

  document.body.appendChild(oDiv);
}

export function retirarAguarde() {
  if (document.getElementById('divProcessando')) {
    document.getElementById('divProcessando').style.display = 'none';
  }
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) != -1) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function ConfirmaBotao(e, pergunta) {
  if (confirm(pergunta)) {
    e.disabled = true;
    e.value = 'Aguarde...';
    return true;
  } else
    return false;
}

function validarCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf == '') return false;
  // Elimina CPFs invalidos conhecidos    
  if (cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999")
    return false;
  // Valida 1o digito 
  add = 0;
  for (i = 0; i < 9; i++)
    add += parseInt(cpf.charAt(i)) * (10 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
    rev = 0;
  if (rev != parseInt(cpf.charAt(9)))
    return false;
  // Valida 2o digito 
  add = 0;
  for (i = 0; i < 10; i++)
    add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
    rev = 0;
  if (rev != parseInt(cpf.charAt(10))) {
    alert('CPF inválido.');
    return false;
  }
  return true;
}

function SomenteNumero(e) {
  /*var tecla = (window.event) ? event.keyCode : e.which;
  if ((tecla >= 48 && tecla <= 57)) {
    return true;
  }
  else {
    if ((tecla == 8) || (tecla == 13) || (tecla == 9)) {
      return true;
    }
    else {
      return false;
    }
  }*/

  if (window.event) { //IE
    tecla = e.keyCode;
  } else if (e.which) { //FF
    tecla = e.which;
  }
  //teclas dos numemros(0 - 9) de 48 a 57
  //techa==8 é para permitir o backspace funcionar para apagar

  if ((tecla >= 48 && tecla <= 57) || (tecla == 8)) {
    return true;
  } else {
    return false;
  }


}

function formatar(src, mask) {
  var i = src.value.length;
  var saida = mask.substring(i, i + 1);
  var ascii = event.keyCode;
  if (saida == "A") {
    if ((ascii >= 97) && (ascii <= 122)) {
      event.keyCode -= 32;
    } else {
      event.keyCode = 0;
    }
  } else if (saida == "0") {
    if ((ascii >= 48) && (ascii <= 57)) {
      return
    } else {
      event.keyCode = 0
    }
  } else if (saida == "#") {
    return;
  } else {
    src.value += saida;


    if (saida == "A") {
      if ((ascii >= 97) && (ascii <= 122)) {
        event.keyCode -= 32;
      }
    } else {
      return;
    }
  }
}

function DataHora(evento, objeto) {
  var keypress = (window.event) ? event.keyCode : evento.which;
  campo = eval(objeto);
  if (campo.value == '00/00/0000 00:00') {
    campo.value = ""
  }

  caracteres = '0123456789';
  separacao1 = '/';
  separacao2 = ' ';
  separacao3 = ':';
  conjunto1 = 2;
  conjunto2 = 5;
  conjunto3 = 10;
  conjunto4 = 13;
  conjunto5 = 16;
  if ((caracteres.search(String.fromCharCode(keypress)) != -1) && campo.value.length < (16)) {
    if (campo.value.length == conjunto1)
      campo.value = campo.value + separacao1;
    else if (campo.value.length == conjunto2)
      campo.value = campo.value + separacao1;
    else if (campo.value.length == conjunto3)
      campo.value = campo.value + separacao2;
    else if (campo.value.length == conjunto4)
      campo.value = campo.value + separacao3;
    else if (campo.value.length == conjunto5)
      campo.value = campo.value + separacao3;
  } else
    event.returnValue = false;
}

function checkMail(campo) {
  //alert(typeof (campo));
  var textoEmail = "";
  if (typeof (campo) == "string") {
    textoEmail = campo;
  }
  if (typeof (campo) == "object") {
    textoEmail = campo.value;
  }

  if (textoEmail != "") {
    var resultado = false;
    var er = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);

    if (er.test(textoEmail)) {
      resultado = true;
    }

    if (resultado == false) {
      alert('Email inválido!');
    }

    return resultado;
  } else {
    return true;
  }

}

function setColorOnFocus(txt) {
  document.getElementById(txt).style.backgroundColor = "#E7F1FA";
}

function setColorOnBlur(txt) {
  document.getElementById(txt).style.backgroundColor = "White";
}

/***
 * AUTO TAB - ao prencher o campo, automaticamente manda o foco para o próximo!
 ***/
var isNN = (navigator.appName.indexOf("Netscape") != -1);

function autoTab(input, len, e) {
  var keyCode = (isNN) ? e.which : e.keyCode;
  var filter = (isNN) ? [0, 8, 9] : [0, 8, 9, 16, 17, 18, 37, 38, 39, 40, 46];
  if (input.value.length >= len && !containsElement(filter, keyCode)) {
    input.value = input.value.slice(0, len);
    input.form[(getIndex(input) + 1) % input.form.length].focus();
  }

  function containsElement(arr, ele) {
    var found = false, index = 0;
    while (!found && index < arr.length)
      if (arr[index] == ele)
        found = true;
      else
        index++;
    return found;
  }

  function getIndex(input) {
    var index = -1, i = 0, found = false;
    while (i < input.form.length && index == -1)
      if (input.form[i] == input) index = i;
      else i++;
    return index;
  }

  return true;
}

//Fim da Função AutoTab

export function tratarErro(origem, xhr) {
  var txt = origem + "\n";

  if (xhr.message)
    txt += xhr.message + "\n";

  try {
    if (xhr.responseJSON.message)
      txt += xhr.responseJSON.message + "\n";
  } catch (ex) {
  }

  try {
    if (xhr.responseJSON.ExceptionMessage)
      txt += xhr.responseJSON.ExceptionMessage + "\n";
  } catch (ex) {
  }

  try {
    if (xhr.responseJSON.InnerException.InnerException.ExceptionMessage)
      txt += xhr.responseJSON.InnerException.InnerException.ExceptionMessage;
  } catch (ex) {
  }

  alert(txt);
}


function txtBoxFormat(objForm, strField, sMask, evtKeyPress) {
  var i, nCount, sValue, fldLen, mskLen, bolMask, sCod, nTecla;

  if (document.all) { // Internet Explorer
    nTecla = evtKeyPress.keyCode;
  } else if (document.layers) { // Nestcape
    nTecla = evtKeyPress.which;
  } else {
    nTecla = evtKeyPress.which;

    if ((nTecla == 9) || (nTecla == 8)) {
      return true;
    }
  }

  sValue = objForm[strField].value;
  // Limpa todos os caracteres de formatação que
  // já estiverem no campo.
  sValue = sValue.toString().replace("-", "");
  sValue = sValue.toString().replace("-", "");
  sValue = sValue.toString().replace(".", "");
  sValue = sValue.toString().replace(".", "");
  sValue = sValue.toString().replace("/", "");
  sValue = sValue.toString().replace("/", "");
  sValue = sValue.toString().replace("(", "");
  sValue = sValue.toString().replace("(", "");
  sValue = sValue.toString().replace(")", "");
  sValue = sValue.toString().replace(")", "");
  sValue = sValue.toString().replace(" ", "");
  sValue = sValue.toString().replace(" ", "");
  fldLen = sValue.length;
  mskLen = sMask.length;

  i = 0;
  nCount = 0;
  sCod = "";
  mskLen = fldLen;

  while (i <= mskLen) {
    bolMask = ((sMask.charAt(i) == "-") || (sMask.charAt(i) == ":") || (sMask.charAt(i) == ".") || (sMask.charAt(i) == "/"))
    bolMask = bolMask || ((sMask.charAt(i) == "(") || (sMask.charAt(i) == ")") || (sMask.charAt(i) == " "))

    if (bolMask) {
      sCod += sMask.charAt(i);
      mskLen++;
    } else {
      sCod += sValue.charAt(nCount);
      nCount++;
    }
    i++;
  }

  objForm[strField].value = sCod;

  //if (nTecla == 9) { return true; } else {
  if (nTecla != 8) { // backspace
    if (sMask.charAt(i - 1) == "9") { // apenas números...
      if (nTecla == 0) {
        return true;
      } else {
        return ((nTecla > 47) && (nTecla < 58));
      }
    } // números de 0 a 9
    else { // qualquer caracter...
      return true;
    }
  }
  //}
  else {
    return true;
  }
}

